import { connect } from 'react-redux';
import View from './FooterView';
import { setCurrentViewId } from '../WhatIfsActions';
import {
  isWhatIfDirtySelector,
  nullableFpIdSelector,
  planImpactLoadingSelector,
} from '../WhatIfsSelector';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';
import { externalHostSelector } from '../../ConsumerArea/ConsumerAreaSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalId(state, ownProps),
  isWhatIfDirty: isWhatIfDirtySelector(state, ownProps),
  planImpactLoading: planImpactLoadingSelector(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  currentRoute: currentRouteSelector(state, ownProps),
  externalHost: externalHostSelector(state),
});

const mapDispatchToProps = dispatch => ({
  cancel: (isWhatIfDirty, clientId, goalId) => {
    const { ADV } = window;
    if (isWhatIfDirty) {
      ADV.NewFinancialPlan.refreshPlan(true);
    }
    dispatch(setCurrentViewId(clientId, goalId, null));
  },
  applyToPlan: (clientId, goalId, applyToPlanCallback) => {
    applyToPlanCallback.call();
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
